import axios from 'axios'
import { globalConfig } from '@/config'

const localState = {
    data: [],
    engineer: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        phone: '',
        small_image: '',
        service: {
            color: '',
            name: '',
        },
        description: '',
        password: '',
    },
    newEngineer: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        phone: '',
        small_image: '',
        service: {
            color: '',
            name: '',
        },
        description: '',
        password: '',
    },
    engineerFormData: {},
    services: [],
    formDataImg: {},
    request: {
        state: ' ',
        message: '',
    },
}
const actions = {
    getEngineersData({ dispatch, commit }) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .get('/engineers', window.requestConfig)
                    .then((res) => {
                        commit('addAllServices', {
                            data: res.data.data,
                        })
                        commit('engineersData', {
                            data: res.data.data,
                        })
                        resolve()
                    })
                    .catch(() => {
                        // log err
                        reject()
                    })
            })
        })
    },
    getEngineer({ state, dispatch }, id) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`

                axios
                    .get(`/engineers/${id}`, window.requestConfig)
                    .then((res) => {
                        state.engineer = res.data
                        state.request.state = ''
                        state.request.message = ''
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        }
                        reject()
                    })
            })
        })
    },
    addEngineer({ state, dispatch, commit }) {
        return new Promise((resolve, reject) => {
            commit('engineerForm', {
                data: state.newEngineer,
            })
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .post('/engineers', state.engineerFormData, window.requestConfig)
                    .then((res) => {
                        dispatch('getEngineersData')
                        if (state.newEngineer.big_image) {
                            dispatch('updateEngineerAvatar', {
                                id: res.data.id,
                                data: state.formDataImg,
                            })
                        }
                        setTimeout(() => {
                            commit('udpateObject', {
                                data: 'newEngineer',
                            })
                            commit('udpateObject', {
                                data: 'request',
                            })
                        }, 1000)
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
    editEngineer({ state, dispatch, commit }, id) {
        return new Promise((resolve, reject) => {
            commit('engineerForm', {
                data: state.engineer,
            })
            dispatch('checkAuth').then((token) => {
                axios.defaults.headers.common.Authorization = `Bearer ${token}`
                axios
                    .put(
                        `/engineers/${id}`,
                        state.engineerFormData,
                        window.requestConfig,
                    )
                    .then(() => {
                        dispatch('getEngineersData')
                        setTimeout(() => {
                            commit('udpateObject', {
                                data: 'engineer',
                            })
                            commit('udpateObject', {
                                data: 'request',
                            })
                        }, 1000)
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
    updateEngineerAvatar({ state, dispatch }, { id, data }) {
        state.formDataImg = data
        if (id) {
            dispatch('checkAuth').then((token) => {
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'multipart/form-data',
                }
                axios
                    .post(
                        `${globalConfig.baseUrl}/engineers/${id}/image`,
                        data,
                        headers,
                    )
                    .then(() => {
                        dispatch('getEngineersData')
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        }
                    })
            })
        }
    },
    deleteEngineer({ dispatch, commit }, id) {
        return new Promise((resolve, reject) => {
            dispatch('checkAuth').then((res) => {
                axios.defaults.headers.common.Authorization = `Bearer ${res}`
                axios
                    .delete(`/engineers/${id}`, window.requestConfig)
                    .then(() => {
                        dispatch('getEngineersData')
                        resolve()
                    })
                    .catch((err) => {
                        if (err.response.status === 401) {
                            dispatch('resetSession')
                        } else if (err.response.status === 400) {
                            commit('setError', err.response)
                        }
                        reject()
                    })
            })
        })
    },
}
const mutations = {
    setState(state, { type, data }) {
        state[type] = data
    },
    addAllServices(state, { data }) {
        const services = []
        // for (var key in data) {
        data.forEach((el) => {
            services.push(el.service.name)
        })
        // }
        state.services = services
    },
    engineersData(state, { data }) {
        // let engineersData = data
        // let char = ''
        // for (var key in data) {
        // data[key].forEach(el => {
        // if (char.toLowerCase() !== key.toLowerCase()) {
        // el.char = key
        // char = key
        // }
        // engineersData.push(el)
        // })
        // }
        state.data = data
    },
    engineerForm(state, { data }) {
        const engineerData = {
            first_name: data.first_name,
            last_name: data.last_name,
            service_id: data.service.id,
            phone: data.phone,
            email: data.email,
            password: data.password,
        }
        if (data.password === false) {
            delete engineerData.password
        }
        state.engineerFormData = engineerData
    },
    setAvatarEngineer(state, { data, type }) {
        if (type === 'add') {
            state.newEngineer.big_image = data
            state.newEngineer.small_image = data
        } else {
            state.engineer.big_image = data
            state.engineer.small_image = data
        }
    },
    udpateObject(state, { data }) {
        for (const key in state[data]) {
            state[data][key] = ''
        }
    },
}

const getters = {
    getEngineers: (state) => state.data,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
